/* ============================================================
   MAN CAVE — Shopify theme front-end
   Ported from the original static site's assets/js/main.js.
   Behaviour is identical; the cart/catalogue now come from
   Shopify instead of localStorage. Wishlist stays local.
   ============================================================ */
"use strict";

const I = {
  check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="m5 12 4 4 10-10"/></svg>',
  wa: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 3a9 9 0 0 0-7.7 13.6L3 21l4.5-1.2A9 9 0 1 0 12 3Zm5 12.5c-.2.6-1.2 1.1-1.7 1.2-.5.1-1 .1-1.7-.1-.4-.1-.9-.3-1.6-.6a8 8 0 0 1-3-2.6c-.6-.8-1-1.6-1-2.2 0-.6.3-1.1.6-1.4.2-.2.4-.2.5-.2h.4c.2 0 .3 0 .5.4l.6 1.4c0 .2 0 .3-.1.4l-.3.4c-.1.1-.2.2-.1.4.1.2.5.9 1.1 1.4.8.7 1.4.9 1.6 1 .2.1.3.1.4-.1l.5-.6c.2-.2.3-.2.5-.1l1.4.6c.2.1.3.2.4.3v.9Z"/></svg>',
  heart: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M12 20s-7-4.4-9.2-8.3C1.2 8.9 2.6 5.6 5.8 5.6c1.9 0 3.1 1.1 3.9 2.2.8-1.1 2-2.2 3.9-2.2 3.2 0 4.6 3.3 3 6.1C19 15.6 12 20 12 20Z"/></svg>',
  heartFull: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 20s-7-4.4-9.2-8.3C1.2 8.9 2.6 5.6 5.8 5.6c1.9 0 3.1 1.1 3.9 2.2.8-1.1 2-2.2 3.9-2.2 3.2 0 4.6 3.3 3 6.1C19 15.6 12 20 12 20Z"/></svg>',
};

const store = {
  get(k, def) { try { return JSON.parse(localStorage.getItem(k)) ?? def; } catch { return def; } },
  set(k, v) { localStorage.setItem(k, JSON.stringify(v)); },
};

/* ---------- wishlist (unchanged from the original build) ---------- */
const Wishlist = {
  key: "mancave_wishlist",
  all() { return store.get(this.key, []); },
  has(h) { return this.all().includes(h); },
  toggle(h) { let a = this.all(); if (a.includes(h)) a = a.filter((x) => x !== h); else a.push(h); store.set(this.key, a); updateWishBadge(); return a.includes(h); },
  count() { return this.all().length; },
};
function updateWishBadge() {
  const n = Wishlist.count();
  document.querySelectorAll(".wish-count").forEach((el) => { el.textContent = n; el.dataset.empty = n === 0 ? "1" : "0"; });
  document.querySelectorAll("[data-wish]").forEach((b) => {
    const on = Wishlist.has(b.dataset.wish);
    b.classList.toggle("on", on); b.setAttribute("aria-pressed", on);
    b.innerHTML = on ? I.heartFull : I.heart;
  });
}

/* ---------- toast ---------- */
function toast(msg) {
  let wrap = document.querySelector(".toast-wrap");
  if (!wrap) { wrap = document.createElement("div"); wrap.className = "toast-wrap"; document.body.appendChild(wrap); }
  const t = document.createElement("div"); t.className = "toast"; t.setAttribute("role", "status");
  t.innerHTML = `${I.check}<span>${msg}</span>`;
  wrap.appendChild(t);
  setTimeout(() => { t.style.opacity = "0"; t.style.transition = "opacity .3s"; setTimeout(() => t.remove(), 320); }, 2600);
}

/* ---------- header: drawer + search ---------- */
function initHeader() {
  const drawer = document.getElementById("drawer");
  const burger = document.querySelector(".burger");
  if (drawer && burger) {
    const open = () => { drawer.dataset.open = "1"; burger.setAttribute("aria-expanded", "true"); document.body.style.overflow = "hidden"; };
    const close = () => { drawer.dataset.open = "0"; burger.setAttribute("aria-expanded", "false"); document.body.style.overflow = ""; };
    burger.addEventListener("click", open);
    drawer.querySelectorAll("[data-close]").forEach((el) => el.addEventListener("click", close));
    drawer.querySelectorAll(".drawer-links a").forEach((a) => a.addEventListener("click", close));
    document.addEventListener("keydown", (e) => { if (e.key === "Escape") close(); });
  }

  const sBtn = document.getElementById("searchBtn");
  const sPanel = document.getElementById("searchPanel");
  const sInput = document.getElementById("searchInput");
  const sResults = document.getElementById("searchResults");
  const sClose = document.getElementById("searchClose");
  if (!sBtn || !sPanel) return;

  const openSearch = () => { sPanel.hidden = false; requestAnimationFrame(() => { sPanel.classList.add("open"); sInput.focus(); }); };
  const closeSearch = () => { sPanel.classList.remove("open"); setTimeout(() => { sPanel.hidden = true; }, 250); };

  let timer;
  const runSearch = (q) => {
    q = q.trim();
    if (!q) { sResults.innerHTML = `<p class="search-hint">Try &ldquo;moonphase&rdquo;, &ldquo;signature&rdquo;, or &ldquo;steel&rdquo;.</p>`; return; }
    // Shopify predictive search — replaces the original in-memory PRODUCTS filter
    fetch(`${window.MC.routes.search}/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6`)
      .then((r) => r.json())
      .then((d) => {
        const hits = (d.resources?.results?.products) || [];
        sResults.innerHTML = hits.length
          ? hits.map((p) => `<a class="search-hit" href="${p.url}"><img src="${p.image || ""}" alt=""><span><strong>${p.title}</strong><em>${p.type || ""}</em></span><span class="tabular">${p.price || ""}</span></a>`).join("")
          : `<p class="search-hint">No matches for &ldquo;${q}&rdquo;. <a class="link-underline" href="/collections/all">Browse all watches</a>.</p>`;
      })
      .catch(() => { sResults.innerHTML = `<p class="search-hint">Press Enter to search for &ldquo;${q}&rdquo;.</p>`; });
  };

  sBtn.addEventListener("click", () => { sPanel.hidden ? openSearch() : closeSearch(); runSearch(""); });
  sClose?.addEventListener("click", closeSearch);
  sInput?.addEventListener("input", () => { clearTimeout(timer); timer = setTimeout(() => runSearch(sInput.value), 220); });
  document.addEventListener("keydown", (e) => { if (e.key === "Escape" && !sPanel.hidden) closeSearch(); });
}

/* ---------- wishlist UI ---------- */
function initWishlistUI() {
  document.addEventListener("click", (e) => {
    const b = e.target.closest("[data-wish]");
    if (!b) return;
    e.preventDefault();
    const on = Wishlist.toggle(b.dataset.wish);
    toast(on ? "Saved to wishlist" : "Removed from wishlist");
  });
  updateWishBadge();
}

function initWishlistPage() {
  const root = document.querySelector("[data-wishlist]");
  if (!root) return;
  const data = document.querySelector("[data-all-products]");
  let all = [];
  try { all = JSON.parse(data?.textContent || "[]"); } catch { all = []; }
  const render = () => {
    const saved = Wishlist.all();
    const items = all.filter((p) => saved.includes(p.handle));
    if (!items.length) {
      root.innerHTML = `<div class="empty-state"><div style="color:var(--faint)">${I.heart}</div><h3 class="h-serif">Your wishlist is empty</h3><p class="muted">Tap the heart on any watch to save it here.</p><a class="btn btn-primary mt-1" href="/collections/all">Browse watches</a></div>`;
      return;
    }
    root.innerHTML = `<div class="product-grid">${items.map((p) => `
      <article class="card">
        <button class="card-wish" data-wish="${p.handle}" aria-label="Save ${p.title} to wishlist"></button>
        <a class="card-media" href="${p.url}" aria-label="${p.title}">
          <img src="${p.image}" alt="${p.title}" loading="lazy">
        </a>
        <div class="card-body">
          <h3>${p.title}</h3>
          <span class="card-sub">${p.tagline || ""}</span>
          <div class="card-foot">
            ${p.compareAt ? `<span class="price"><span class="was tabular">${p.compareAt}</span><span class="tabular">${p.price}</span></span>` : `<span class="price tabular">${p.price}</span>`}
            ${p.available ? `<a class="btn btn-ghost btn-sm" href="${p.url}">View</a>` : `<span class="badge-inline">Notify me</span>`}
          </div>
        </div>
      </article>`).join("")}</div>`;
    updateWishBadge();
  };
  render();
  root.addEventListener("click", (e) => { if (e.target.closest("[data-wish]")) setTimeout(render, 0); });
}

/* ---------- floating WhatsApp button ---------- */
function initWhatsAppFloat() {
  if (document.querySelector(".wa-float")) return;
  const a = document.createElement("a");
  a.className = "wa-float";
  a.href = "https://wa.me/" + (window.MC?.whatsapp || "9710000000000");
  a.target = "_blank"; a.rel = "noopener";
  a.setAttribute("aria-label", "Chat with us on WhatsApp");
  a.innerHTML = I.wa;
  document.body.appendChild(a);
}

/* ---------- placeholder categories (unchanged from the original build) ---------- */
const CATEGORIES = [
  { name: "Signature", sub: "Everyday", img: "cat-01.jpg" },
  { name: "Dual Calendar", sub: "Complication", img: "cat-02.jpg" },
  { name: "Lunar Calendar", sub: "Moonphase", img: "cat-03.jpg" },
  { name: "Date-Master", sub: "Classic", img: "cat-04.jpg" },
  { name: "Quadris", sub: "Compact 21mm", img: "cat-05.jpg" },
  { name: "Limited Edition", sub: "Numbered", img: "cat-06.jpg" },
];
function initCategories() {
  const grids = document.querySelectorAll("[data-categories]");
  if (!grids.length) return;
  const base = document.querySelector('link[rel="stylesheet"][href*="styles.css"]')?.href.replace(/styles\.css.*$/, "") || "";
  grids.forEach((grid) => {
    grid.innerHTML = CATEGORIES.map((c) => `
      <a class="cat-card" href="/collections/all" aria-label="${c.name} (placeholder category)">
        <span class="cat-img"><img src="${base}${c.img}" alt="${c.name} — placeholder category" loading="lazy"></span>
        <span class="cat-label"><span>${c.sub}</span><h3>${c.name}</h3></span>
      </a>`).join("");
  });
}

/* ---------- shop filters ---------- */
function initShopFilters() {
  const grid = document.querySelector("[data-shop-grid]");
  if (!grid) return;
  const count = document.querySelector("[data-shop-count]");
  const cards = [...grid.querySelectorAll("[data-card-wrap]")];
  const apply = (f) => {
    let shown = 0;
    cards.forEach((c) => {
      const avail = c.dataset.available === "1";
      const show = f === "all" || (f === "available" && avail) || (f === "soon" && !avail);
      c.style.display = show ? "" : "none";
      if (show) shown++;
    });
    if (count) count.textContent = `${shown} ${shown === 1 ? "piece" : "pieces"}`;
  };
  apply("all");
  document.querySelectorAll("[data-filter]").forEach((btn) => {
    btn.addEventListener("click", () => {
      document.querySelectorAll("[data-filter]").forEach((b) => b.setAttribute("aria-pressed", "false"));
      btn.setAttribute("aria-pressed", "true");
      apply(btn.dataset.filter);
    });
  });
}

/* ---------- product detail ---------- */
function initProduct() {
  const root = document.querySelector("[data-pdp]");
  if (!root) return;

  // gallery
  const mainImg = root.querySelector("[data-gallery-main] img");
  const thumbs = root.querySelector("[data-thumbs]");
  const thumbList = () => Array.from(thumbs?.querySelectorAll(".thumb") || []);

  function selectThumb(b) {
    if (!b || !mainImg) return;
    mainImg.src = b.dataset.src;
    thumbList().forEach((t) => t.setAttribute("aria-selected", "false"));
    b.setAttribute("aria-selected", "true");
    b.scrollIntoView({ block: "nearest", inline: "nearest" });
  }

  thumbs?.addEventListener("click", (e) => {
    const b = e.target.closest(".thumb"); if (!b) return;
    selectThumb(b);
  });

  // prev / next arrows over the main image — wrap around at either end
  function stepGallery(delta) {
    const list = thumbList(); if (!list.length) return;
    let i = list.findIndex((t) => t.getAttribute("aria-selected") === "true");
    if (i < 0) i = 0;
    selectThumb(list[(i + delta + list.length) % list.length]);
  }
  root.querySelector("[data-gallery-prev]")?.addEventListener("click", () => stepGallery(-1));
  root.querySelector("[data-gallery-next]")?.addEventListener("click", () => stepGallery(1));

  // variants — chips drive the real Shopify variant id
  let variants = [];
  try { variants = JSON.parse(document.querySelector("[data-variants]")?.textContent || "[]"); } catch {}
  const idField = root.querySelector("[data-variant-id]");
  const priceEl = root.querySelector("[data-price]");
  const optWrap = root.querySelector("[data-options]");

  const chosen = [];
  optWrap?.querySelectorAll("[data-opt]").forEach((grp) => {
    const i = +grp.dataset.optIndex;
    const pressed = grp.querySelector('.chip[aria-pressed="true"]') || grp.querySelector(".chip");
    chosen[i] = pressed?.dataset.val || "";
  });

  const syncVariant = () => {
    const match = variants.find((v) => chosen.every((val, i) => !val || v.options[i] === val));
    if (!match) return;
    if (idField) idField.value = match.id;
    if (priceEl && window.MC?.moneyFormat) {
      priceEl.textContent = formatMoney(match.price);
    }
    const addBtn = root.querySelector("[data-add-cart]");
    if (addBtn) {
      addBtn.disabled = !match.available;
      addBtn.textContent = match.available ? "Add to cart" : "Sold out";
    }
  };

  optWrap?.addEventListener("click", (e) => {
    const chip = e.target.closest(".chip"); if (!chip) return;
    const grp = chip.closest("[data-opt]");
    grp.querySelectorAll(".chip").forEach((c) => c.setAttribute("aria-pressed", "false"));
    chip.setAttribute("aria-pressed", "true");
    chosen[+grp.dataset.optIndex] = chip.dataset.val;
    syncVariant();
  });
  syncVariant();

  // qty
  const qtyInput = root.querySelector("[data-qty]");
  root.querySelector("[data-qty-minus]")?.addEventListener("click", () => { qtyInput.value = Math.max(1, +qtyInput.value - 1); });
  root.querySelector("[data-qty-plus]")?.addEventListener("click", () => { qtyInput.value = +qtyInput.value + 1; });
}

function formatMoney(cents) {
  const fmt = window.MC?.moneyFormat || "{{amount}}";
  const amount = (cents / 100).toLocaleString("en-AE", { minimumFractionDigits: 0, maximumFractionDigits: 2 });
  return fmt.replace(/\{\{\s*amount[^}]*\}\}/, amount);
}

/* ---------- scroll reveal (unchanged from the original build) ---------- */
/* ---------- page transition (logo fade) ---------- */
function initPageFade() {
  const el = document.querySelector("[data-page-fade]");
  if (!el) return;

  // Respect a reduced-motion preference: drop the overlay entirely.
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    el.remove();
    return;
  }

  const LEAVE_MS = 300;

  document.addEventListener("click", (e) => {
    // Something else already handled this click (cart drawer, search, etc.).
    if (e.defaultPrevented) return;
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

    const a = e.target.closest("a");
    if (!a || !a.href) return;
    if (a.target && a.target !== "_self") return;
    if (a.hasAttribute("download") || a.hasAttribute("data-no-fade")) return;

    const href = a.getAttribute("href") || "";
    if (/^(#|mailto:|tel:|javascript:)/i.test(href)) return;
    if (a.origin !== window.location.origin) return;          // external site
    if (a.href.split("#")[0] === window.location.href.split("#")[0]) return; // same page

    e.preventDefault();
    el.classList.add("is-leaving");
    setTimeout(() => { window.location.href = a.href; }, LEAVE_MS);
  });

  // Restored from the back/forward cache: the overlay would otherwise still be up.
  window.addEventListener("pageshow", (e) => {
    if (e.persisted) el.classList.remove("is-leaving");
  });
}

/* ---------- home video band ---------- */
function initVideoBand() {
  const wrap = document.querySelector("[data-video-band]");
  if (!wrap) return;
  const video = wrap.querySelector("video");
  if (!video) return;

  // Muted + inline is what makes browsers allow autoplay at all.
  video.muted = true;
  video.loop = true;
  video.playsInline = true;
  video.setAttribute("playsinline", "");

  // Only load and play once the band is actually on screen, so visitors who
  // never scroll this far never download the file.
  let loaded = false;
  const play = () => {
    if (!loaded) { video.preload = "auto"; video.load(); loaded = true; }
    video.play().catch(() => {});
  };

  if ("IntersectionObserver" in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => (e.isIntersecting ? play() : video.pause()));
    }, { threshold: 0.25 });
    io.observe(wrap);
  } else {
    play();
  }

  // Audio can only start from a real user gesture.
  const btn = wrap.querySelector("[data-video-sound]");
  const label = wrap.querySelector("[data-video-sound-label]");
  btn?.addEventListener("click", () => {
    video.muted = !video.muted;
    const on = !video.muted;
    wrap.classList.toggle("is-muted", !on);
    btn.setAttribute("aria-pressed", String(on));
    btn.setAttribute("aria-label", on ? "Turn sound off" : "Turn sound on");
    if (label) label.textContent = on ? "Sound off" : "Sound on";
    if (on) video.play().catch(() => {});
  });

  document.addEventListener("visibilitychange", () => {
    if (document.hidden) video.pause();
  });
}

function initReveal() {
  if (matchMedia("(prefers-reduced-motion: reduce)").matches) return;
  const sels = [".split-media", ".split > div", ".card", ".trust-item", ".quote",
    ".news", ".panel", ".pdp-info", ".gallery-main", ".details-grid > div",
    ".cat-card", ".page-hero .eyebrow", ".page-hero h1", ".page-hero .lead",
    ".section > .container > .center", ".prose > h2"];
  const set = new Set();
  sels.forEach((s) => document.querySelectorAll(s).forEach((el) => set.add(el)));
  const items = [...set].filter((el) => !el.closest(".hero-inner"));
  items.forEach((el) => {
    el.classList.add(el.classList.contains("gallery-main") || el.classList.contains("cat-card") ? "reveal-zoom" : "reveal");
    const p = el.parentElement;
    if (p && (p.classList.contains("product-grid") || p.classList.contains("trust") || p.classList.contains("quotes") || p.classList.contains("cat-grid"))) {
      const idx = [...p.children].indexOf(el);
      el.style.transitionDelay = Math.min(idx, 8) * 70 + "ms";
    }
  });
  if (!("IntersectionObserver" in window)) { items.forEach((el) => el.classList.add("in")); return; }
  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); } });
  }, { threshold: 0.1, rootMargin: "0px 0px -6% 0px" });
  const vh = window.innerHeight || 800;
  items.forEach((el) => {
    if (el.getBoundingClientRect().top < vh * 0.92) el.classList.add("in");
    else io.observe(el);
  });
}

/* ---------- boot ---------- */
document.addEventListener("DOMContentLoaded", () => {
  initHeader();
  initWishlistUI();
  initWishlistPage();
  initCategories();
  initShopFilters();
  initProduct();
  initWhatsAppFloat();
  initVideoBand();
  initPageFade();
  initReveal();
});
